var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "105px",
    height: "107px",
    viewBox: "0 0 105 107",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "responsiveSmall") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BAEF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07C87A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB3780",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA8800",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "new-website",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy",
    transform: "translate(-187.000000, -180.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "responsiveSmall",
    transform: "translate(187.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.166,99.9100423 L10.179,99.9100423 C7.48943125,99.9177428 4.90565532,98.8628837 2.99,96.975 C1.0796315,95.1244752 0.000847636234,92.5786896 0,89.919 L0,9.99 C0.00100366237,7.33063418 1.07978425,4.78521711 2.99,2.935 C4.90565532,1.04711634 7.48943125,-0.00774279861 10.179,-4.23253531e-05 L66.166,-4.23253531e-05 C68.8555687,-0.00774279861 71.4393447,1.04711634 73.355,2.935 C75.2652158,4.78521711 76.3439963,7.33063418 76.345,9.99 L76.345,89.919 C76.3441524,92.5786896 75.2653685,95.1244752 73.355,96.975 C71.4393447,98.8628837 68.8555687,99.9177428 66.166,99.9100423 L66.166,99.9100423 Z M27.994,93.419 C27.994,94.7997119 29.1132881,95.919 30.494,95.919 L40.763,95.919 C42.1437119,95.919 43.263,94.7997119 43.263,93.419 C43.263,92.0382881 42.1437119,90.919 40.763,90.919 L30.494,90.919 C29.1132881,90.919 27.994,92.0382881 27.994,93.419 Z",
    id: "Subtraction_5",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.166,7.634 L10.179,7.634 C9.49175678,7.59105777 8.81917427,7.8453701 8.33227218,8.33227218 C7.8453701,8.81917427 7.59105777,9.49175678 7.634,10.179 L7.634,83.979 C7.59105777,84.6662432 7.8453701,85.3388257 8.33227218,85.8257278 C8.81917427,86.3126299 9.49175678,86.5669422 10.179,86.524 L66.166,86.524 C66.8532432,86.5669422 67.5258257,86.3126299 68.0127278,85.8257278 C68.4996299,85.3388257 68.7539422,84.6662432 68.711,83.979 L68.711,10.179 C68.7539422,9.49175678 68.4996299,8.81917427 68.0127278,8.33227218 C67.5258257,7.8453701 66.8532432,7.59105777 66.166,7.634 Z",
    id: "Path_1898",
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.718,106.435 L64.179,106.435 C58.5637432,106.418522 54.0159268,101.870258 54,96.255 L54,35.178 C54.0170245,29.5635227 58.564521,25.0164729 64.179,25 L94.718,25 C100.33365,25.0148261 104.882967,29.5623558 104.9,35.178 L104.9,96.255 C104.884065,101.871425 100.334428,106.420169 94.718,106.435 Z M79.448,96.255 C77.3400594,96.2555523 75.6316319,97.9647258 75.632,100.072666 C75.6323682,102.180607 77.3413926,103.889184 79.4493332,103.889 C81.5572739,103.888816 83.266,102.179941 83.266,100.072 C83.2637944,97.964453 81.5555475,96.2566536 79.448,96.255 Z",
    id: "Subtraction_6",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.718,32.634 L64.18,32.634 C63.4927568,32.5910578 62.8201743,32.8453701 62.3332722,33.3322722 C61.8463701,33.8191743 61.5920578,34.4917568 61.635,35.179 L61.635,91.166 C61.5920578,91.8532432 61.8463701,92.5258257 62.3332722,93.0127278 C62.8201743,93.4996299 63.4927568,93.7539422 64.18,93.711 L94.718,93.711 C95.4052432,93.7539422 96.0778257,93.4996299 96.5647278,93.0127278 C97.0516299,92.5258257 97.3059422,91.8532432 97.263,91.166 L97.263,35.179 C97.3059422,34.4917568 97.0516299,33.8191743 96.5647278,33.3322722 C96.0778257,32.8453701 95.4052432,32.5910578 94.718,32.634 Z",
    id: "Path_1901",
    fill: "#FFF3E0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet);
export default __webpack_public_path__ + "static/media/tablet.4ec28d243e10357a2c39c688206a7510.svg";
export { ForwardRef as ReactComponent };